<template>
<div class="chapter">
<div class="inner_page">
<div epub:type="cover" style="text-align:center;">
<img alt="1.png" src="image/cover.jpg" style="max-width:100%;"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?ad5c39a6